export const polystyreneFoam = [
  {
    title: 'ППС 13Ф',
    'compressive': {prefix: 'не менее', value: 70},
    'flexural': {prefix: 'не менее', value: 130},
    'thermalConductivity10': {prefix: 'не более', value: 0.039},
    'thermalConductivity25': {prefix: 'не более', value: 0.041},
    'humidity': {prefix: 'не более', value: 3.0},
    'waterAbsorption': {prefix: 'не более', value: 4.0},
  },
  {
    title: 'ППС 16Ф',
    'compressive': {prefix: 'не менее', value: 90},
    'flexural': {prefix: 'не менее', value: 180},
    'thermalConductivity10': {prefix: 'не более', value: 0.036},
    'thermalConductivity25': {prefix: 'не более', value: 0.038},
    'humidity': {prefix: 'не более', value: 2.0},
    'waterAbsorption': {prefix: 'не более', value: 2.0},
  }
]